import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";

export type EmailTemplateDomain = "tracking" | "return";

export default function useGetAllShopEmailTemplatesSuspense(
  shopId: string,
  domain: EmailTemplateDomain = "tracking",
) {
  return $api.useSuspenseQuery("get", "/shops/{shopId}/email-templates", {
    params: { path: { shopId }, query: { domain } },
  });
}

export function useGetAllShopEmailTemplates(
  shopId: string,
  domain: EmailTemplateDomain = "tracking",
) {
  return $api.useQuery("get", "/shops/{shopId}/email-templates", {
    params: { path: { shopId }, query: { domain } },
  });
}

export const invalidateAllShopEmailTemplatesKey = (shopId: string) => [
  "get",
  "/shops/{shopId}/email-templates",
  { params: { path: { shopId } } },
];

export function useInvalidateAllShopEmailTemplates(shopId: string) {
  const queryClient = useQueryClient();
  return () => {
    return queryClient.refetchQueries({
      queryKey: invalidateAllShopEmailTemplatesKey(shopId),
    });
  };
}
